import { render, staticRenderFns } from "./notJoinClass.vue?vue&type=template&id=b539abda&scoped=true"
import script from "./notJoinClass.vue?vue&type=script&lang=js"
export * from "./notJoinClass.vue?vue&type=script&lang=js"
import style0 from "./notJoinClass.vue?vue&type=style&index=0&id=b539abda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b539abda",
  null
  
)

export default component.exports